var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from "vue";
import TypeCheck from "../../TypeCheck";
var dialogCount = 0;
var DEFAULT_TITLE = "弹框", DEFAULT_HEIGHT = "auto", DEFAULT_WIDTH = "auto", DEFAULT_CLOSEBTN = true, DEFAULT_ZINDEX = 1000, DEFAULT_SHADE = 0.1;
var createDialogWrapper = function () {
    var con;
    con = document.createElement("div");
    con.style.display = "none";
    con.id = "dialog-customer-wrapper";
    document.body.appendChild(con);
    return con;
};
var normalizeProps = function (options) {
    if (!options) {
        options = {};
    }
    console.log('---------------', options.title);
    if (TypeCheck.isString(options.title)) {
        options.title = options.title || DEFAULT_TITLE;
    }
    else if (TypeCheck.isArray(options.title)) {
        options.title = options.title;
    }
    else {
        options.title = !!options.title;
    }
    options.height = options.height || DEFAULT_HEIGHT;
    options.width = options.width || DEFAULT_WIDTH;
    options.closeBtn = options.closeBtn;
    if (TypeCheck.isNumber(options.height)) {
        options.height = options.height + "px";
    }
    if (TypeCheck.isNumber(options.width)) {
        options.width = options.width + "px";
    }
    if (TypeCheck.isBoolean(options.closeBtn)) {
        options.closeBtn = options.closeBtn ? 1 : 0;
    }
    return options;
};
var Dialog = function (constructor, props, options) {
    if (props === void 0) { props = {}; }
    if (options === void 0) { options = {}; }
    options = normalizeProps(options);
    var DialogConstructor = Vue.extend(constructor);
    var instance = new DialogConstructor(__assign({ el: document.createElement("div") }, props));
    Object.keys(props).forEach(function (item) {
        instance[item] = props[item];
    });
    var con = createDialogWrapper();
    con.appendChild(instance.$el);
    dialogCount++;
    var promise = new Promise(function (resolve, reject) {
        Vue.nextTick(function () {
            con.style.display = "block";
            var index = layer.open(__assign({ type: 1, shadeClose: false, zIndex: DEFAULT_ZINDEX, title: options.title, shade: DEFAULT_SHADE, resize: false, closeBtn: options.closeBtn, area: [options.width, options.height], content: $(instance.$el) }, options, { end: function () {
                    con.remove();
                    resolve(instance);
                    instance.$destroy();
                    instance = null;
                    dialogCount--;
                    if (dialogCount == 0) {
                        layer.index = 0;
                        layer.zIndex = DEFAULT_ZINDEX;
                    }
                } }));
            instance.$dialogIndex = index;
        });
    });
    return {
        instance: instance,
        promise: promise
    };
};
export default Dialog;
